<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zZW0Fm/tc-custom/9781960332691.jpg?1721404701829" alt="This image is the cover for the book Gabardine Gang"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gabardine Gang
      </h1>
      <p class="bookDescription body article font2">
        <p>THE GABARDINE GANG: Power and Betrayal in Hartford's Mob Scene by Kevin B. DiBacco is a riveting tale of crime, family, and redemption in the gritty underworld of the 1950s and 1960s Hartford, Connecticut.      Geno DiBacco led the notorious Gabardine Gang, a small-time mob that ruled the city. Geno's son, Kevin, takes you on a visceral journey through his childhood and adolescence, revealing the gang's illegal activities, his father's dramatic descent, and the harsh realities of organized crime, offering a unique perspective on a world often glamorized in Hollywood.      This book offers a profound look at the DiBacco family's struggles amid racial tensions and the personal costs of a life entwined with crime. Geno's battle with gambling addiction and the impact of his choices on his family paint a vivid picture of a man and a community at a crossroads.     THE GABARDINE GANG explores the intricate dynamics of family, resilience, and personal redemption. Kevin's authentic storytelling immerses readers in a world where every twist and turn resonates with genuine emotion.     Don't miss your chance to experience this raw and unfiltered exploration of a bygone era.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin B. DiBacco
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8579e2de